// actionTypes.js

/* SHOW/HIDE */
export const SHOW_HEADER = "SHOW_HEADER";
export const SHOW_FOOTER = "SHOW_FOOTER";
export const SHOW_SIDEBAR = "SHOW_SIDEBAR";
export const TOGGLE_LEFTMENU = "TOGGLE_LEFTMENU";
export const SHOW_RIGHT_SIDEBAR = "SHOW_RIGHT_SIDEBAR";


/* CHANGE LAYOUT */
export const CHANGE_LAYOUT = "CHANGE_LAYOUT";
export const CHANGE_LAYOUT_WIDTH = "CHANGE_LAYOUT_WIDTH";
export const CHANGE_SIDEBAR_THEME = "CHANGE_SIDEBAR_THEME";
export const CHANGE_SIDEBAR_THEME_IMAGE = "CHANGE_SIDEBAR_THEME_IMAGE";
export const CHANGE_SIDEBAR_TYPE = "CHANGE_SIDEBAR_TYPE";
export const CHANGE_TOPBAR_THEME = "CHANGE_TOPBAR_THEME";
export const CHANGE_PRELOADER = "CHANGE_PRELOADER";
export const CHANGE_LAYOUT_MODE = "CHANGE_LAYOUT_MODE";
